// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"151":"8be147ec","206":"96024a68","514":"d672bd2c","611":"f8307b65","857":"89a6fb37","977":"b2b7bd59"}[chunkId] + ".chunk.js";
};